import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import RatingActions, { RatingRedux, RatingTypes } from '../../Redux/ParentPlatform/RatingRedux'
import { notificationSuccess, notificationFail } from '../../Redux/NotificationActions'

const RatingCRUDObservable = createCRUDObservable({
  mainRedux: RatingRedux,
  reduxPath: 'parent_platform_rating',
})

const submitRatingEpic = (action$, store, { Api }) => (
  action$.ofType(RatingTypes.submitRatingRequest)
    .mergeMap(({ ratingInfo }) => (
      Observable
        .fromPromise(Api.parent_platform_rating.submit(ratingInfo)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              RatingActions.submitRatingError(response.error),
              notificationFail('Accion Fallida')
            ]
          }
          return [
            RatingActions.submitRatingSuccess(response),
            notificationSuccess('Accion Exitosa')
          ]
        })
    ))
)

export const ratingObservers = Object.assign({}, RatingCRUDObservable.observers, {})
export const ratingEpic = combineEpics(
  RatingCRUDObservable.epic,
  submitRatingEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ParentPlatform/RatingObserver.js